var render = function render(){var _vm=this,_c=_vm._self._c;return _c('text-content',_vm._g({attrs:{"size":'sm1',"weight":_vm.weight,"line-height":'lh-xl',"decoration":_vm.decoration}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }